import React from "react";
import "./Styles/sectionTwo.css";
import Banner1 from "../Banners/1.png";
export default function SectionTwo() {
  return (
    <div className="sectionTwo">
      <div>
        <img src={Banner1} alt="" />
      </div>
    </div>
  );
}
